import hoistNonReactStatics from 'hoist-non-react-statics'
import { connect } from 'react-redux'

import getComponentDisplayName from 'shared/utils/getComponentDisplayName'

/**
 * @param ComposedComponent
 * @param [componentMapStateToProps]
 * @returns {Component}
 */
const withShopAndRuntimeConfig = (
  ComposedComponent,
  componentMapStateToProps
) => {
  const mapStateToProps = (state, ownProps) => {
    const { publicRuntimeConfig, shopConfig } = state
    let originalProps = {}
    if (typeof componentMapStateToProps === 'function') {
      originalProps = componentMapStateToProps(state, ownProps)
    }
    return {
      ...originalProps,
      publicRuntimeConfig,
      shopConfig,
    }
  }
  const StoreProviderWrapper = connect(mapStateToProps)(ComposedComponent)
  StoreProviderWrapper.displayName = `withShopAndRuntimeConfig(${getComponentDisplayName(
    ComposedComponent
  )})`
  hoistNonReactStatics(StoreProviderWrapper, ComposedComponent)
  return StoreProviderWrapper
}

export default withShopAndRuntimeConfig
